import React from "react";
import { Outlet } from "react-router-dom";
import { Logo } from "@/assets/svg/Logo";
import { useTranslation } from "react-i18next";

export function PublicLayout() {
  const { t } = useTranslation();

  return (
    <div className="h-screen overflow-y-auto">
      <div className="flex min-h-screen items-center justify-center bg-background px-4 py-12 sm:px-6 lg:px-8">
        <div className="w-full max-w-md">
          <div className="mb-2 flex justify-start">
            <div className="h-16 w-16">
              <Logo />
            </div>
          </div>
          <h1 className="mb-10 text-5xl font-extrabold text-foreground">
            {t("login.insights")}
          </h1>
          <Outlet />
        </div>
      </div>
    </div>
  );
}
